import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "redux";

import {
    AggregateConnectionQualityStatistics,
    ConnectionQualityStateEntry,
    ConnectionStats,
} from "Types/ConnectionStats";

import { recomputeConnectionQualityState } from "./utils";

export type { AggregateConnectionQualityStatistics, ConnectionQualityStateEntry };

export type ConnectionQualityState = {
    [taskSid: string]: ConnectionQualityStateEntry;
};

const initialState: ConnectionQualityState = {};

const ConnectionQualityStateSlice = createSlice({
    name: "ConnectionQualityState",
    initialState,
    reducers: {
        setConnectionQualityStatistics(
            state: ConnectionQualityState,
            action: PayloadAction<{ taskSid: string; statisticsAndSampleCount: ConnectionQualityStateEntry }>
        ) {
            state[action.payload.taskSid] = action.payload.statisticsAndSampleCount;
        },
        removeConnectionQualityStatistics(state: ConnectionQualityState, action: PayloadAction<string>) {
            delete state[action.payload];
        },
    },
});

export const { setConnectionQualityStatistics, removeConnectionQualityStatistics } =
    ConnectionQualityStateSlice.actions;
export default ConnectionQualityStateSlice.reducer;

// SELECTORS
export const selectConnectionQualityStatistics = (state: RootState) => state.conference.connectionQuality;

// THUNKS
export function updateConnectionQualityStatistics(taskSid: string, newRawStatistics: ConnectionStats) {
    return function thunk(dispatch: Dispatch, getState: () => RootState): void {
        const currentConnectionQualityData = getState().conference.connectionQuality[taskSid] as
            | ConnectionQualityStateEntry
            | undefined;
        const newConnectionQualityData = recomputeConnectionQualityState(
            newRawStatistics,
            currentConnectionQualityData
        );

        dispatch(
            setConnectionQualityStatistics({
                taskSid,
                statisticsAndSampleCount: newConnectionQualityData,
            })
        );
    };
}
